import { render, staticRenderFns } from "./PDPMainContainer.vue?vue&type=template&id=22bfab7d&"
import script from "./PDPMainContainer.vue?vue&type=script&lang=js&"
export * from "./PDPMainContainer.vue?vue&type=script&lang=js&"
import style0 from "./PDPMainContainer.vue?vue&type=style&index=0&id=22bfab7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports